// extracted by mini-css-extract-plugin
module.exports = {"customLink":"styles_customLink__WhlxU","isDisabled":"styles_isDisabled__NUyz3"};